import { Vue, i18n } from "Common/vue";

// import components
import Autocomplete from "./../components/vue/Autocomplete.vue";
import Minicart from "../components/vue/Minicart.vue";
import CompanyColors from "../components/vue/CompanyColors.vue";

import "Ui/toggle";
import "./navigation";

window.$_autocomplete = new Vue({
    i18n,
    render: (h) => h(Autocomplete),
}).$mount("#autocomplete");

window.$_minicart = new Vue({
    i18n,
    render: (h) => h(Minicart),
}).$mount("#minicart");

let companyColorsElement = document.querySelector(".js-company-colors");
if (companyColorsElement) {
    window.$_companyColors = new Vue({
        i18n,
        render: (h) =>
            h(CompanyColors, {
                props: {
                    helpLink: companyColorsElement.getAttribute("data-link"),
                    selectedColorId: companyColorsElement.getAttribute("data-selected-color-id"),
                },
            }),
    }).$mount(companyColorsElement);
}

document.querySelector(".js-trigger-search").addEventListener("click", (event) => {
    event.preventDefault();

    Event.dispatch("Autocomplete.showForm");
});

document.querySelectorAll(".js-company-colors-trigger").forEach((trigger) => {
    trigger.addEventListener("click", () => {
        const opener = document.querySelector(".js-company-color-opener");
        if (opener) {
            const event = new MouseEvent("click", {
                bubbles: false,
                cancelable: true,
                view: window,
            });

            opener.dispatchEvent(event);
        }
    });
});
